import services from '../services'
import * as types from './mutation-types'

// ========== FORMS ==========

export const GetForms = async ({ commit }, params) => {
  commit(types.SET_IS_LOADING, true)
  try {
    const res = await services.listForms(params)
    commit(types.SET_FORMS, res.data)
  } finally {
    commit(types.SET_IS_LOADING, false)
  }
}

export const GetForm = async ({ commit }, id) => {
  commit(types.SET_IS_LOADING, true)
  try {
    const res = await services.getFormBuilder(id)
    const form = res.data.data
    commit(types.SET_FORM, form)
    commit(types.SET_FIELDS, form.fields || [])
    commit(types.SET_CONDITIONS, form.conditions || [])
    commit(types.SET_IS_DIRTY, false)
  } finally {
    commit(types.SET_IS_LOADING, false)
  }
}

export const CreateForm = async ({ commit }, payload) => {
  const res = await services.createForm(payload)
  commit(types.SET_FORM, res.data.data)
  return res.data.data
}

export const UpdateForm = async ({ commit }, { id, payload }) => {
  const res = await services.updateForm(id, payload)
  commit(types.SET_FORM, res.data.data)
  return res.data.data
}

export const SaveFormComplete = async ({ commit, state }) => {
  commit(types.SET_IS_LOADING, true)
  try {
    const payload = {
      form: {
        name: state.form.name,
        slug: state.form.slug,
        description: state.form.description,
        settings: state.form.settings,
        status: state.form.status,
        submit_text: state.form.submit_text,
        success_title: state.form.success_title,
        success_message: state.form.success_message,
        translations: state.form.translations || undefined
      },
      fields: state.fields.map((field, index) => ({
        ...field,
        order: index,
        translations: field.translations || undefined
      })),
      conditions: state.conditions.map((condition, index) => ({
        ...condition,
        order: index
      }))
    }

    const res = await services.saveFormComplete(state.form.id, payload)
    const form = res.data.data

    commit(types.SET_FORM, form)
    commit(types.SET_FIELDS, form.fields || [])
    commit(types.SET_CONDITIONS, form.conditions || [])
    commit(types.SET_IS_DIRTY, false)

    return form
  } finally {
    commit(types.SET_IS_LOADING, false)
  }
}

export const ChangeFormStatus = async ({ commit }, id) => {
  const res = await services.changeFormStatus(id)
  return res.data.data
}

export const DuplicateForm = async ({ commit }, id) => {
  const res = await services.duplicateForm(id)
  return res.data.data
}

export const DeleteForm = async ({ commit }, id) => {
  await services.deleteForm(id)
}

// ========== FIELD TYPES ==========

export const GetFieldTypes = async ({ commit }) => {
  const res = await services.getFieldTypes()
  commit(types.SET_FIELD_TYPES, res.data.data)
}

export const GetFieldTypesGrouped = async ({ commit }) => {
  const res = await services.getFieldTypesGrouped()
  commit(types.SET_FIELD_TYPES_GROUPED, res.data.data)
}

// ========== FIELDS (LOCAL) ==========

export const AddField = ({ commit, state }, payload) => {
  // Generate temporary ID if new field
  if (!payload.id) {
    payload._tempId = 'temp_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
  }
  payload.order = state.fields.length
  commit(types.ADD_FIELD, payload)
}

export const UpdateField = ({ commit }, payload) => {
  commit(types.UPDATE_FIELD, payload)
}

export const RemoveField = ({ commit }, payload) => {
  commit(types.REMOVE_FIELD, payload)
}

export const ReorderFields = ({ commit }, orderedFields) => {
  commit(types.REORDER_FIELDS, orderedFields)
}

export const SelectField = ({ commit }, field) => {
  commit(types.SET_SELECTED_FIELD, field)
}

export const ClearSelectedField = ({ commit }) => {
  commit(types.SET_SELECTED_FIELD, null)
}

// ========== CONDITIONS ==========

export const GetConditionOperators = async ({ commit }) => {
  const res = await services.getConditionOperators()
  commit(types.SET_OPERATORS, res.data.data)
}

export const GetConditionActions = async ({ commit }) => {
  const res = await services.getConditionActions()
  commit(types.SET_ACTIONS, res.data.data)
}

export const AddCondition = ({ commit }, payload) => {
  if (!payload.id) {
    payload._tempId = 'temp_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
  }
  commit(types.ADD_CONDITION, payload)
}

export const UpdateCondition = ({ commit }, payload) => {
  commit(types.UPDATE_CONDITION, payload)
}

export const RemoveCondition = ({ commit }, payload) => {
  commit(types.REMOVE_CONDITION, payload)
}

// ========== UTILITY ==========

export const ClearForm = ({ commit }) => {
  commit(types.SET_FORM, null)
  commit(types.SET_FIELDS, [])
  commit(types.SET_CONDITIONS, [])
  commit(types.SET_SELECTED_FIELD, null)
  commit(types.SET_IS_DIRTY, false)
}

export const SetDirty = ({ commit }, value) => {
  commit(types.SET_IS_DIRTY, value)
}
